import {Component, Inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {StorageService} from './core/services/storage.service';
import {RETURN_URL} from './app.config';
import {environment} from '../environments/environment';
import {TokenRefreshService} from './core/services/token-refresh.service';

@Component({
    selector: 'pas-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'ostso.front';

    readonly exceptions = ['/login', '/restore-password', '/logout', '/', '/access-denied']

    constructor(
        private router: Router,
        private storage: StorageService,
        @Inject(RETURN_URL) private returnURL: string,
        private tokenRefreshService: TokenRefreshService,
    )
    {
        this.tokenRefreshService.startMonitoring()
        if (environment.production === true) return;
        this.router.events.subscribe(() => {
            if (this.exceptions.every(e=>e!==this.router.url))
            {
                this.storage.setItem(this.returnURL, this.router.url);
            }
        });


    }


}
